import { Component, Input, OnInit, OnChanges, Output, EventEmitter } from '@angular/core';
import { gameCodeFilter, GamesService } from 'src/app/apis/games.service';
import { AppCore } from 'src/app/utils/classes/app-core';

@Component({
  selector: 'app-select-game',
  templateUrl: './select-game.component.html',
  styleUrls: ['./select-game.component.scss'],
})
export class SelectGameComponent extends AppCore implements OnInit, OnChanges {
  @Input() selectedCurrency: string;
  @Output() DataString = new EventEmitter();

  gameFilter: gameCodeFilter[];
  selectedGame: string[] = [];

  gameType = this.constDataPreload?.game?.game_type;

  showFilterGameType = false;

  checkAll = false;

  constructor(private svGame: GamesService) {
    super();
  }

  ngOnInit() {}
  ngOnChanges() {
    console.log(this.selectedCurrency);
    if (this.selectedCurrency) {
      this.getGamesByCurrencyForFilter(this.selectedCurrency);
    }
  }

  getGamesByCurrencyForFilter(currency: string) {
    this.svGame.getGamesByCurrencyForFilter(currency).subscribe((res) => {
      this.gameFilter = res;
      this.gameFilter.forEach((x) => (x.checked = false));
      this.checkAll = true;
    });
  }

  OnChangesSelectedGame() {
    this.selectedGame = this.gameFilter.filter((x) => x.checked).map((y) => y.game_code);
    if (this.selectedGame.length == this.gameFilter.length || this.selectedGame.length == 0) {
      this.checkAll = true;
      this.DataString.emit('');
    } else {
      this.checkAll = false;
      this.DataString.emit(this.selectedGame.join(','));
    }
  }

  onCheckAll() {
    this.checkAll = !this.checkAll;
    if (this.checkAll) {
      this.gameFilter.forEach((x) => (x.checked = false));
    }
    this.OnChangesSelectedGame();
  }
}
